/* Theme-owned scheduling; Gorgias still owns its scripts and configuration. */
(() => {
  const config = document.currentScript?.dataset;
  if (!config || window.hydromateGorgiasScheduled) return;
  window.hydromateGorgiasScheduled = true;
  let started = false;
  let fallback;
  let idle;
  const start = () => {
    if (started) return;
    started = true;
    clearTimeout(fallback);
    if (idle !== undefined && window.cancelIdleCallback) cancelIdleCallback(idle);
    window.removeEventListener('load', afterLoad);
    document.removeEventListener('pointerover', onIntent, true);
    document.removeEventListener('focusin', onIntent, true);
    document.removeEventListener('click', onIntent, true);
    for (const [kind, url] of [['chat', config.chatUrl], ['convert', config.convertUrl], ['mailto-replace', config.mailtoUrl]]) {
      // An editor re-enabling the vendor embed must not install a second copy.
      if (!url || document.querySelector(`[data-gorgias-loader-${kind}]`)) continue;
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.setAttribute(`data-gorgias-loader-${kind}`, '');
      document.head.appendChild(script);
    }
  };
  const afterLoad = () => {
    if (started) return;
    if (window.requestIdleCallback) idle = requestIdleCallback(start, { timeout: 2000 });
    else { clearTimeout(fallback); fallback = setTimeout(start, 200); }
  };
  const onIntent = event => {
    if (event.target.closest?.('a[href^="mailto:"], [data-gorgias-open-chat], #gorgias-chat-container')) start();
  };
  if (config.productPage !== 'true') return start();
  // Start on support intent; ordinary product taps do not trigger extra app work.
  for (const event of ['pointerover', 'focusin', 'click']) document.addEventListener(event, onIntent, true);
  // Slow unrelated resources must not keep the integration unavailable forever.
  fallback = setTimeout(start, 5000);
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
})();
